// Global snackbar/toast slice. A single transient message (severity +
// text) shown by <SnackbarHost />, mounted once at the app root. Any slice or
// component can surface feedback by dispatching showSnackbar({ message, severity }).
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  severity: 'info', // 'success' | 'info' | 'warning' | 'error'
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      const { message, severity = 'info' } = action.payload || {};
      state.open = true;
      state.message = message || '';
      state.severity = severity;
    },
    hideSnackbar: (state) => {
      state.open = false;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
